var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBvlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 60,
    viewBox: "0 0 431 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.186 295.705C194.524 248.573 227.626 145.004 250 89.4678C123 77.4678 98.5 142.892 97 145.968C93.4321 153.284 57.5 239.968 17 338.468C64.4938 344.116 95.6427 338.803 115.252 332.296C135.16 325.69 154.101 313.512 165.186 295.705Z",
    fill: "url(#paint0_linear_1701_8039)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M340.719 290.053C366.607 241.894 392.585 147.71 414 94.5542C287 82.5542 280.226 125.001 270 145.968C266.432 153.284 230.5 239.968 190 338.468C237.917 344.166 265.842 341.957 283.923 336.821C308.18 329.93 328.78 312.264 340.719 290.053Z",
    fill: "url(#paint1_linear_1701_8039)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176 275.554C137.5 329.554 61 306.554 43 275.054L31.5 303.054C51.5 329.554 138.4 368.354 176 275.554Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.557 156.335C145.692 148.542 106.242 160.266 88 167.102C93.5 151.054 100.51 135.378 107.5 129.054C208.256 108.033 192.847 179.92 178.527 191.713C260.359 183.509 262.405 255.803 259.336 275.286C256.621 292.524 274.835 270.093 285.096 255.978C314.311 215.791 376.664 140.009 413.5 96.0542L386 174.054C354.29 215.243 302.093 282.464 295.137 292.719C288.182 302.973 280.305 308.955 277.237 310.664C242.5 326.554 230.029 307.347 232.5 292.719C243 230.554 213.817 218.887 201.031 220.938C197.791 220.596 184.153 219.913 155.511 219.913C119.096 217.451 129.087 198.72 138.634 189.662C149.885 181.8 169.423 164.128 157.557 156.335Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1701_8039",
    x1: 75.5,
    y1: 214.554,
    x2: 198.5,
    y2: 220.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49256D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73247F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1701_8039",
    x1: 215,
    y1: 220,
    x2: 423,
    y2: 204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49256D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410761,
    stopColor: "#802676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D02784"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBvlogo);
export default __webpack_public_path__ + "static/media/bvlogo.24ae7675043eb67ab4ecb0c85a5cb72a.svg";
export { ForwardRef as ReactComponent };